import { FormProvider, useForm } from "react-hook-form";
import { defaultValues as defaultFormValues } from "./constants";
import { LinklyPairFormValues, schema } from "./types";
import { yupResolver } from "@hookform/resolvers/yup";

export interface LinklyPairFormProviderProps {
  children?: React.ReactNode;
  defaultValues?: Partial<LinklyPairFormValues>;
}

export const LinklyPairFormProvider = ({
  children,
  defaultValues,
}: LinklyPairFormProviderProps) => {
  const methods = useForm<LinklyPairFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { ...defaultFormValues, ...defaultValues },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
